import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { checklistAnswerContract } from 'shared/domain/checklistAnswer/checklistAnswerContract';
import { makeErrorPublisher, makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastChecklistAnswerError = makeErrorPublisher(
  checklistAnswerContract
);

export const broadcastCreatedChecklistAnswer = makeEventPublisher(checklistAnswerContract, DomainMessagesTypes.checklistAnswerCreated);

export const broadcastUpdatedChecklistAnswer = makeEventPublisher(checklistAnswerContract, DomainMessagesTypes.checklistAnswerUpdated);

export const broadcastDeletedChecklistAnswer = makeEventPublisher(checklistAnswerContract, DomainMessagesTypes.checklistAnswerDeleted);

export const broadcastChecklistAnswerOperationError = (
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void => {
  debugLog('broadcastChecklistAnswerOperationError', error, uniqueId, messageId);
  broadcastChecklistAnswerError(DomainMessagesTypes.failUploadedEntity, error, {
    uniqueId,
    messageId: messageId ?? undefined,
  });
};
